import { useQuery } from '@tanstack/react-query';

import { MessagingUnreadCounts } from '~hooks/useMessaging/models';
import {
  messagingUnreadCountsQueryOptions,
  unreadCountsVisibleTo,
} from '~queries/useMessagingUnreadCountsQuery';

export default function useMessagingUnreadCountSelectorQuery(
  selectCount: (unreadCounts: MessagingUnreadCounts) => number,
  { isEnabled = true }: { isEnabled?: boolean } = {},
) {
  const visibleUnreadCounts = unreadCountsVisibleTo(isEnabled);
  const { data: unreadCount = 0 } = useQuery({
    ...messagingUnreadCountsQueryOptions(isEnabled),
    select: (unreadCounts) => selectCount(visibleUnreadCounts(unreadCounts)),
  });

  return { unreadCount };
}
